import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=0fc2bc5a&"
import script from "./Network.vue?vue&type=script&lang=ts&"
export * from "./Network.vue?vue&type=script&lang=ts&"
import style0 from "./Network.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports